module.exports = __webpack_public_path__ + "static/media/fraispetitfour.a1cea5d3.JPG";